import { EventBusActionType, EventBusEntityType, eventBusUtil } from '../util/event-bus-util'
import { browserUtil, tokenService } from '@grndhouse/react-common'
import React, { createContext, useCallback, useEffect, useState } from 'react'

export type SessionData = {
  isLoading: boolean
  isLoggedIn: boolean
  redirectUrl: string | undefined
}
export const SessionContext = createContext<SessionData>({} as SessionData)

export const SessionContextProvider = ({ children }: { children: React.ReactElement }): React.ReactElement => {
  const [isLoading, setIsLoading] = useState(true)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  const [redirectUrl] = useState(getRedirectFromLocation())

  const checkIfLoggedIn = useCallback((): void => {
    setIsLoggedIn(tokenService.hasAccessToken())
  }, [])

  useEffect(() => {
    setIsLoading(true)
    checkIfLoggedIn()
    setIsLoading(false)

    const subscription = eventBusUtil().subscribe(
      { actions: [EventBusActionType.CREATE, EventBusActionType.REMOVE], entities: [EventBusEntityType.ACCESS_TOKEN] },
      async () => checkIfLoggedIn(),
    )
    return () => {
      subscription.unsubscribe()
    }
  }, [checkIfLoggedIn])

  return <SessionContext.Provider value={{ isLoggedIn, isLoading, redirectUrl }}>{children}</SessionContext.Provider>
}

const getRedirectFromLocation = (): string | undefined => {
  const url = new URL(browserUtil.location())
  const search = new URLSearchParams(url.search)
  return search.get('redirect') ?? undefined
}
